import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// ページ遷移アニメーション設定
const pageVariants = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -16 },
};

const pageTransition = {
  duration: 0.35,
  ease: 'easeOut',
};

// --- SVGアイコン ---
const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

/**
 * 全ページ共通レイアウトコンポーネント
 * - ページ遷移アニメーション
 * - フッター
 * - 統一されたパディング管理
 */
const PageLayout = ({ children }) => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <motion.div
      className="page-layout"
      key={location.pathname}
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
    >
      <div className="page-layout-content">
        {children}
      </div>

      {/* フッター */}
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-links">
            <a href="mailto:sota.yo4da@gmail.com" className="footer-link">
              <MailIcon />
              <span>sota.yo4da@gmail.com</span>
            </a>
            <a
              href="https://www.linkedin.com/in/Yo4da-Sota-166166372"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              <LinkedInIcon />
              <span>LinkedIn</span>
            </a>
          </div>
          <p className="footer-copy">
            © {new Date().getFullYear()} {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </motion.div>
  );
};

export default PageLayout;
